import { render, staticRenderFns } from "./SuccessAlert.vue?vue&type=template&id=0f48551e"
import script from "./SuccessAlert.vue?vue&type=script&lang=ts"
export * from "./SuccessAlert.vue?vue&type=script&lang=ts"
import style0 from "./SuccessAlert.vue?vue&type=style&index=0&id=0f48551e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports